import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.GetDevPlanItemsRequest;
const ACTIONS    = [
  ActionType.GetDevPlanItemsRequest,
  ActionType.GetDevPlanItemsResponse,
  ActionType.GetDevPlanItemsError,
];


type Payload = boolean;

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to get the dev plan items made by the user
 */
export const getDevPlanItemsAction = (projectId: number, participantId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetDevPlanItems,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({ projectId, participantId, languageId: state.locale.lang.languageId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['devPlan', 'items'], payload, successState);
};


export const getDevPlanItemsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
